import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import toast from 'react-hot-toast';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import CustomMenu from "../../../common/CustomMenu";
import CustomRecCard from '../../../common/CustomRecCard';
import CustomButton from '../../../common/CustomButton';
import PatientDetail from './PatientDetailV2';
import YesNo from '../SubComponents/YesNo';

import usePrompt from '../../../hooks/usePrompt';
import useEmail from '../../../hooks/useEmail';

import { GenerateEmail, FilterEmailContent, GetDischargedPatients, UpdatePatientDisplayType, UpdateDPList, } from '../../../redux/v2/patient-invite/actions';
import { RiLoader4Line } from 'react-icons/ri';
import CustomTable from '../../../common/CustomTable';
import { parseJSON } from '../../../utils';



function PatientListV2(props) {
    const { account } = props.User;
    const { list, count } = props.PatientInvite?.patients;
    const { etList, cetList, getSuggestedPrograms, SetModalProperties, screenSize } = props;
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [listCondition, setListCondition] = useState({
        timeline: 7,
        display_type: 0,
    });

    // useEffect(() => {
    // if (account?.user?.therapist_id) {

    //     props?.UpdateDPList();

    //     let lc = { ...listCondition };
    //     // lc?.timeline == 0 && delete lc?.timeline;

    //     props?.GetDischargedPatients(1, 100, { therapist_id: account?.user?.therapist_id, ...lc }, {
    //         column: "bdp.date_of_last_appointment",
    //         order: "desc",
    //     });
    // }
    // }, [account?.user?.therapist_id, listCondition]);

    const { arrangeEmailPrompt, arrangeFilteredEmailPrompt } = usePrompt();
    const { arrangeEmailContent } = useEmail();

    const PreviewPatientEmail = async (item) => {
        setSelectedPatient(item);
        const ge = item.generatedEmails.filter(g => g.filtered == 0)
        const fge = item.generatedEmails.filter(g => g.filtered == 1)
        const noGenEmails = ge?.length == 0 && fge?.length == 0;

        let resGE, resFE;
        if (noGenEmails) {
            const toastID = toast.loading(`Generating Email for ${(item?.first_name + " " + item?.last_name).toUpperCase()}...`);
            const emailProcessedPrompt = await arrangeEmailPrompt({
                ...item,
                sp: getSuggestedPrograms(item?.suggested_programs)
            }, props.PatientInvite.emailFilterPrompt?.text,);

            resGE = await props.GenerateEmail(emailProcessedPrompt, item?.id);
            const geContent = await arrangeEmailContent(parseJSON(resGE?.data?.email_content));

            const filteredEmailProcessedPrompt = await arrangeFilteredEmailPrompt(geContent, props.PatientInvite.emailFilterPrompt?.text);
            resFE = await props.FilterEmailContent(filteredEmailProcessedPrompt, item?.id, resGE?.data);

            toast.dismiss(toastID);
        }


        SetModalProperties({
            id: "patient-detail-wrapper",
            height: "100%",
            isShow: true,
            title: "",
            body: (
                <>
                    <PatientDetail pd={{
                        ...item,
                        generatedEmails: noGenEmails ? [{ ...resFE?.data }, { ...resGE?.data }] : item?.generatedEmails
                    }} emailTemplates={etList} customEmailTemplates={cetList} suggestedPrograms={getSuggestedPrograms(item?.suggested_programs, 20)} />
                </>
            ),
            actions: [],
        });
    }

    const screenCondition = screenSize != "xl" && screenSize != "l";

    return (
        <div className="patient-list">

            <div>
                <CustomTable
                    id="pi-c-list"
                    store={props.PatientInvite?.patients}
                    table={{
                        headers: screenCondition ? [
                            { title: "PATIENT INFO", },
                            { title: "RECOMMEND?", align: "center" },
                        ] : [
                            { title: "PATIENT NAME", },
                            { title: "DISCHARGED DATE", },
                            { title: "CASE NAME", },
                            { title: "RECOMMEND?", align: "center" },
                        ],
                        body: (item, i) => {
                            return (
                                <tr className={`pi-c-l ${(i + 1) % 2 === 0 ? "" : "tr-even"}`}>
                                    {
                                        screenCondition ? (
                                            <td>
                                                <div className="patient-info">
                                                    <h6>
                                                        {`${item?.first_name} ${item?.last_name}`}
                                                    </h6>
                                                    <h6>{`Discharge Date: ${moment(item?.date_of_last_appointment).format("MM/DD/YYYY")}`}</h6>
                                                    <h6>{`Case: ${item?.case_description}`}</h6>
                                                </div>
                                            </td>
                                        ) : (
                                            <>
                                                <td>
                                                    <div>
                                                        <h6>
                                                            {`${item?.first_name} ${item?.last_name}`}
                                                        </h6>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        <h6>{moment(item?.date_of_last_appointment).format("MM/DD/YYYY")}</h6>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        <h6>{item?.case_description}</h6>
                                                    </div>
                                                </td>
                                            </>
                                        )
                                    }

                                    {
                                        listCondition?.display_type == 0 && (
                                            <td className="yn">
                                                <YesNo displayType={listCondition?.display_type} pd={item} yesCB={() => {
                                                    PreviewPatientEmail(item);
                                                }} noCB={() => {
                                                    props?.UpdatePatientDisplayType(item?.id, -1);
                                                }} />
                                            </td>
                                        )
                                    }

                                    {
                                        listCondition?.display_type == 1 && (
                                            <td>
                                                <div className='flex-c-col'>
                                                    <h6>Yes</h6>
                                                    <h6>{moment(item?.emailSentLogs?.[item?.emailSentLogs?.length - 1]?.date_sent).format("MM/DD/YYYY")}</h6>
                                                </div>
                                            </td>
                                        )
                                    }

                                    {
                                        listCondition?.display_type == -1 && (
                                            <td className="yn">
                                                <YesNo displayType={listCondition?.display_type} pd={item} yesCB={() => {
                                                    PreviewPatientEmail(item);
                                                }} noCB={() => {
                                                    props?.UpdatePatientDisplayType(item?.id, 0);
                                                }} />
                                            </td>
                                        )
                                    }


                                </tr>
                            )
                        }
                    }}
                    actions={{
                        getDependency: { value: account?.user?.therapist_id, key: "therapist_id" },
                        get: (page, count, filter, sort) => {
                            props?.GetDischargedPatients(page, count, filter, sort);
                        },
                        filters: [
                            {
                                label: "Discharge Date:",
                                key: "timeline",
                                options: [
                                    { label: 'Last 7 Days', value: 7 },
                                    { label: 'Last 14 Days', value: 14 },
                                    { label: 'Last 30 Days', value: 30 },
                                    { label: 'All Time', value: 0 },
                                ],
                            },
                            {
                                label: "Status:",
                                key: "display_type",
                                options: [
                                    { label: 'Open', value: 0 },
                                    { label: 'Recommended', value: 1 },
                                    { label: 'Not Recommended', value: -1 },
                                ],
                            }
                        ],
                        emptyTable: props?.UpdateDPList
                    }}
                />
            </div>
        </div >
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    PatientInvite: state.PatientInvite,
});

export default connect(mapStateToProps, {
    GenerateEmail,
    UpdateDPList,
    FilterEmailContent,
    GetDischargedPatients,
    UpdatePatientDisplayType,
})(PatientListV2);
